export default __webpack_public_path__ + "static/media/integrations.ab67e97c.png";